import React from "react";
import format from "date-fns/format";

import LocationOnIcon from "@material-ui/icons/LocationOn";
import { Theme, useMediaQuery } from "@material-ui/core";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { WeatherDaily } from "interfaces/Weather";
import Rain from "components/Icons/Rain";
import Loader from "components/Loader";
import { getWeatherIconPath } from "utils/weather";

import useStyles from "./styles";

export interface Props {
  selectedFacility: racehorse360.IFacility;
  relativeDay: string;
  weather: WeatherDaily;
  loading: boolean;
  date: Date;
  isWeatherServiceAvailable: boolean;
}

const WeatherInfo = (props: Props) => {
  const {
    selectedFacility,
    weather,
    relativeDay,
    loading,
    date,
    isWeatherServiceAvailable
  } = props;

  const classes = useStyles({
    backgroundColor: selectedFacility?.backgroundColor
  });
  const isScreenDownSM = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );

  const isValid = obj => {
    return obj && Boolean(Object.values(obj).length);
  };

  const renderWeatherDailyContent = (weather: WeatherDaily) => {
    return (
      isValid(weather) && (
        <div className={classes.indicators}>
          <div className={classes.picWrapper}>
            <img
              src={getWeatherIconPath(weather.weather[0])}
              alt={weather.weather[0].main}
            />
          </div>

          <div className={classes.temperature}>
            <span className={classes.temperatureDay}>
              {Math.round(weather.temp.day)}°
            </span>
            <span className={classes.temperatureNight}>
              {Math.round(weather.temp.night)}°
            </span>
          </div>

          <div className={classes.humidity}>
            <Rain className={classes.humidityIcon} />
            <div className={classes.humidityText}>{weather.humidity}%</div>
            <span
              className={classes.humidityPercent}
              style={{ width: `${weather.humidity}%` }}
            />
          </div>
        </div>
      )
    );
  };

  const renderWeatherDailyBlock = () => {
    if (loading) {
      return <Loader size={20} />;
    }

    return isWeatherServiceAvailable ? (
      renderWeatherDailyContent(weather)
    ) : (
      <div className={classes.outOfServiceText}>
        Weather data is temporarily unavailable
      </div>
    );
  };

  return (
    <>
      <div className={classes.weatherInfo}>
        <div className={classes.weekDayLocationContainer}>
          <span className={classes.weekDay}>
            {format(date, "eeee, MMM d")}
            <span>{` ${relativeDay}`}</span>
          </span>
          <span className={classes.weekDayShort}>
            {format(date, "eee, MMM d")}
            <span>{` ${relativeDay}`}</span>
          </span>
          <div className={classes.location}>
            <LocationOnIcon className={classes.locationIcon} />
            <span className={classes.locationName}>
              {selectedFacility?.code}
            </span>
          </div>
        </div>

        {isScreenDownSM && renderWeatherDailyBlock()}
      </div>
    </>
  );
};

export default React.memo(WeatherInfo);
